import { ReactNode } from 'react';
import { SelectOption } from 'modules/queryBuilder/contexts';
import { useTranslation } from 'modules/queryBuilder/hooks/useTranslation';
import { SelectValueType } from 'ui/selects';
import { isString } from 'utils/tsHelpers';

export const useQueryBuilderSelectTooltipContent = (
  value: ReactNode | string,
  options: SelectOption<SelectValueType>[],
) => {
  const { t } = useTranslation();
  if (options.length === 0) {
    return {
      isEnabled: true,
      tooltipContent: t('storybook.tooltips.noOptions'),
    };
  } else if (isString(value) && value.length > 65) {
    return {
      isEnabled: true,
      tooltipContent: value,
    };
  } else {
    return {
      isEnabled: false,
    };
  }
};
